import { DateHelper } from "../../helper";
import { Page } from "../../constants";
import { GraphRequestBaseService } from "../GraphRequestBase.service";
import { getGraphURL } from "../serviceHelper";
import omit from "lodash/omit";

const fields = ["Title", "eRequestStatus", "eRequestType", "eContent", "eComments", "eApprovalProcess", "createdHrId"];

const BASE_URL = getGraphURL(Page.applicationForLeave);
class AFLService extends GraphRequestBaseService {
  constructor(public baseURL: string, public fields: string[]) {
    super(baseURL, fields);
  }
  toRequest(data: any) {
    const stringifyKeys = ["eApprovalProcess", "eSteps", "eVacationPeriods", "eAttachments", "vRegID", "createdHrId"];

    for (const key of stringifyKeys) {
      if (data?.[key]) data[key] = JSON.stringify(data[key]);
    }

    return omit(data, ["eApprovedBy"]);
  }
  toResponse(response: any = {}) {
    const fields = response.fields;
    if (typeof fields["eAttachments"] === "string") {
      fields["eAttachments"] = JSON.parse(fields["eAttachments"]);
    }
    if (typeof fields["eSteps"] === "string") {
      fields["eSteps"] = JSON.parse(fields["eSteps"]);
    }
    if (typeof fields["eApprovalProcess"] === "string") {
      fields["eApprovalProcess"] = JSON.parse(fields["eApprovalProcess"]);
    }
    if (typeof fields["eComments"] === "string") {
      fields["eComments"] = JSON.parse(fields["eComments"]);
    }
    if (typeof fields["eVacationPeriods"] === "string") {
      const parsed = JSON.parse(fields["eVacationPeriods"]);
      fields["eVacationPeriods"] = DateHelper.rangeDateListToMoment(parsed);
    }
    if (typeof fields["eExpectedReturnDate"] === "string") {
      fields["eExpectedReturnDate"] = DateHelper.formatDateToMoment(fields["eExpectedReturnDate"]);
    }
    if (typeof fields["eEmployeeBirthday"] === "string") {
      fields["eEmployeeBirthday"] = DateHelper.formatDateToMoment(fields["eEmployeeBirthday"]);
    }
    if (typeof fields["eTerminationContractTime"] === "string") {
      fields["eTerminationContractTime"] = DateHelper.formatDateToMoment(fields["eTerminationContractTime"]);
    }

    return {
      ...fields,
      eCreatedBy: `${response.createdBy.user.email}|${response.createdBy.user.displayName}`,
      createdDateTime: response.createdDateTime,
    };
  }
}

export const applicationForLeaveApi = new AFLService(BASE_URL, fields);
